/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const en_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const es_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const fr_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return `Covoiturez et économisez`
};

const it_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const nl_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const pt_routecosts__blablacar_card__title = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.routecosts__blablacar_card__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("routecosts__blablacar_card__title", locale)
	if (locale === "de") return de_routecosts__blablacar_card__title(inputs)
	if (locale === "en") return en_routecosts__blablacar_card__title(inputs)
	if (locale === "es") return es_routecosts__blablacar_card__title(inputs)
	if (locale === "fr") return fr_routecosts__blablacar_card__title(inputs)
	if (locale === "it") return it_routecosts__blablacar_card__title(inputs)
	if (locale === "nl") return nl_routecosts__blablacar_card__title(inputs)
	return pt_routecosts__blablacar_card__title(inputs)
};